
export const companyInfo = {
  name: "Smith Have & Anlæg ApS",
  tagline: "Professionelt anlægsarbejde & haveprojekter i Nordjylland",
  phone: "+45 26 33 23 24",
  email: "Info@smithhaveoganlaeg.dk",
  address: "Blokhusvej 25, 9490 Pandrup",
  cvr: "42139696",
  facebook: "https://www.facebook.com/p/HaveHjem-Multiservice-61580850720402/",
  instagram: "https://www.instagram.com/smith_haveoganlaeg",
  description: "Smith Have & Anlæg ApS tilbyder professionelle løsninger inden for anlægsarbejde og haveprojekter, med særligt fokus på belægning, støttemure og rullegræs. Vi skaber funktionelle og æstetiske uderum af høj kvalitet.",
};

export const services = [
  {
    id: "nyanlaeg",
    slug: "nyanlaeg",
    title: "Nyanlæg",
    description: "Vi skaber din drømmehave fra bunden med fokus på design og funktionalitet.",
    fullDescription: "Står du med en nybygget bolig eller en have, der trænger til en total forvandling? Vi tilbyder nyanlæg af haver, hvor vi tager hånd om alt fra jordarbejde til den sidste plante er sat. Vi rådgiver om materialevalg og havedesign, så du får et uderum, der passer til din livsstil.",
    features: [
      "Totaletablering af nye haver",
      "Havedesign og rådgivning",
      "Jordarbejde og planering",
      "Etablering af bede og stier",
      "Beplantningsplaner"
    ],
    icon: "Shovel",
    image: "",
    gallery: [
      "/kundebilleder/imageye___-_imgi_67_666971542_122134739847028357_2233004686136187369_n.jpeg",
      "/kundebilleder/imageye___-_imgi_67_662824623_122134739907028357_8056706768858079315_n.jpeg"
    ]
  },
  {
    id: "belagning",
    slug: "belagning",
    title: "Belægning & Omlægning",
    description: "Professionel lægning og renovering af fliser til indkørsler og terrasser.",
    fullDescription: "Uanset om du skal have en helt ny indkørsel eller omlagt din gamle terrasse, sikrer vi et holdbart og flot resultat. Vi har stor erfaring med alle typer fliser og sten, og vi sørger for det vigtige bundarbejde, så din belægning forbliver jævn i mange år.",
    features: [
      "Nye indkørsler og terrasser",
      "Omlægning af eksisterende fliser",
      "Trappeanlæg og støttemure",
      "Kantsten og afgrænsninger",
      "Reparation af sætningsskader"
    ],
    icon: "LayoutGrid",
    image: "/imageye___-_imgi_67_548783026_122097008931028357_2922094312626478033_n.jpeg",
    gallery: [
      "/imageye___-_imgi_67_548783026_122097008931028357_2922094312626478033_n.jpeg",
      "/kundebilleder/imageye___-_imgi_67_672023651_122135999259028357_6691622361253398711_n.jpeg",
      "/kundebilleder/imageye___-_imgi_67_672196004_122135999001028357_8116323758983306129_n.jpeg",
      "/kundebilleder/imageye___-_imgi_67_673808045_122135999193028357_9162352892792381928_n.jpeg",
      "/kundebilleder/imageye___-_imgi_67_580119984_122112884895028357_8356522089783807349_n.jpeg"
    ]
  },
  {
    id: "maskinkoersel",
    slug: "maskinkoersel",
    title: "Maskinkørsel",
    description: "Effektivt gravearbejde og jordflytning med moderne maskiner.",
    fullDescription: "Vi råder over maskiner til både store og små opgaver. Fra udgravning til fundamenter og trampestier til planering af større arealer. Vores erfarne maskinførere sikrer, at arbejdet bliver udført præcist og effektivt, uanset pladsforholdene.",
    features: [
      "Udgravning til fundamenter",
      "Planering af grunde",
      "Gravearbejde i haver",
      "Bortkørsel af jord og affald",
      "Arbejde med minigraver"
    ],
    icon: "Truck",
    image: "",
    gallery: []
  },
  {
    id: "graesplaener",
    slug: "graesplaener",
    title: "Græsplæner & Rullegræs",
    description: "Etablering af smukke græsplæner via såning eller rullegræs.",
    fullDescription: "En flot grøn plæne er hjertet i mange haver. Vi tilbyder både traditionel såning af græs og udlægning af rullegræs for et øjeblikkeligt resultat. Vi sørger for den rette jordforberedelse, så græsset får de bedste betingelser for at trives.",
    features: [
      "Udlægning af rullegræs",
      "Såning af nye plæner",
      "Vertikalskæring og pleje",
      "Topdressing",
      "Jordforberedelse og fræsning"
    ],
    icon: "Sprout",
    image: "/kundebilleder/imageye___-_imgi_67_667357066_122134739817028357_4663739399389733083_n.jpeg",
    gallery: [
      "/kundebilleder/imageye___-_imgi_67_667357066_122134739817028357_4663739399389733083_n.jpeg"
    ]
  },
  {
    id: "haekkeklip",
    slug: "haekkeklip",
    title: "Hækkeklip",
    description: "Professionel klipning og vedligeholdelse af alle typer hække.",
    fullDescription: "Vi sørger for, at din hæk altid står skarpt og velplejet. Vi tilbyder både enkeltstående klipninger og faste aftaler, så du slipper for besværet. Vi klipper alle typer hække og sørger naturligvis for at tage affaldet med os, hvis det ønskes.",
    features: [
      "Klipning af alle hæktyper",
      "Formklipning",
      "Nedskæring af gamle hække",
      "Bortkørsel af haveaffald",
      "Faste serviceaftaler"
    ],
    icon: "Scissors",
    image: "",
    gallery: [
      "/kundebilleder/imageye___-_imgi_67_561726936_122107579503028357_2110243252969052305_n.jpeg"
    ]
  },
  {
    id: "groen-vedligehold",
    slug: "groen-vedligehold",
    title: "Grøn vedligehold",
    description: "Vi holder din have smuk og sund året rundt med professionel pleje.",
    fullDescription: "En have kræver pleje for at forblive smuk. Vi tilbyder alt inden for grøn vedligeholdelse, herunder lugning af bede, kantskæring, gødskning og generel oprydning. Vi skræddersyr en løsning, der passer til netop dit behov og din haves størrelse.",
    features: [
      "Lugning og pleje af bede",
      "Kantskæring af plæner",
      "Gødskning og ukrudtsbekæmpelse",
      "Sæsonoprydning",
      "Vedligeholdelse af erhvervsarealer"
    ],
    icon: "Leaf",
    image: "",
    gallery: [
      "/kundebilleder/imageye___-_imgi_67_668583084_122135105049028357_2729473811509692273_n.jpeg",
      "/kundebilleder/imageye___-_imgi_67_667405123_122135105097028357_7106171026018513753_n.jpeg"
    ]
  },
  {
    id: "beskaering-traefaeldning",
    slug: "beskaering-traefaeldning",
    title: "Beskæring & Træfældning",
    description: "Sikker fældning af træer og professionel beskæring af buske.",
    fullDescription: "Har du træer, der skygger for meget, eller buske, der er vokset ud af kontrol? Vi udfører sikker træfældning og professionel beskæring, der sikrer planternes sundhed og havens lysindfald. Vi har det rette udstyr til at løse opgaven sikkert og effektivt.",
    features: [
      "Træfældning og sektionsfældning",
      "Beskæring af frugttræer",
      "Udtynding af buske",
      "Stubfræsning",
      "Bortkørsel af stammer og grene"
    ],
    icon: "Axe",
    image: "",
    gallery: [
      "/kundebilleder/imageye___-_imgi_67_549612918_122097008937028357_6381845376905140419_n.jpeg"
    ]
  },
  {
    id: "vintertjeneste",
    slug: "vintertjeneste",
    title: "Vintertjeneste",
    description: "Vi sørger for sikre veje og stier med snerydning og saltning.",
    fullDescription: "Når vinteren rammer, står vi klar til at hjælpe med snerydning og saltning. Vi tilbyder vintertjeneste til både private og erhverv, så du er sikret farbare arealer og overholder dine forpligtelser som grundejer. Vi rykker hurtigt ud, når behovet opstår.",
    features: [
      "Snerydning af fortove og stier",
      "Saltning og grusning",
      "Snerydning af indkørsler",
      "Erhvervsaftaler",
      "Beredskab hele vinteren"
    ],
    icon: "Snowflake",
    image: "",
    gallery: []
  },
  {
    id: "stottemur",
    slug: "stottemur",
    title: "Støttemur",
    description: "Opbygning af støttemure der både er funktionelle og dekorative.",
    fullDescription: "Støttemure er en fantastisk måde at håndnere niveauforskelle på, samtidig med at de tilføjer karakter til haven. Vi bygger solide og smukke støttemure i forskellige materialer, der passer til din haves stil.",
    features: [
      "L-sten og betonmure",
      "Naturstensmure",
      "Højbede i forskellige niveauer",
      "Sikring af skrænter",
      "Dekorative havemure"
    ],
    icon: "BrickWall",
    image: "/kundebilleder/imageye___-_imgi_67_668896790_122135104761028357_6348603269610059595_n.jpeg",
    gallery: [
      "/kundebilleder/imageye___-_imgi_67_668896790_122135104761028357_6348603269610059595_n.jpeg",
      "/kundebilleder/imageye___-_imgi_67_579930003_122112884889028357_6553736803778612460_n.jpeg"
    ]
  },
  {
    id: "anlaegsopgaver",
    slug: "anlaegsopgaver",
    title: "Anlægsopgaver",
    description: "Vi håndterer alt fra rydning af gamle haver til etablering af nye uderum.",
    fullDescription: "Vores generelle anlægsopgaver dækker bredt over alt det arbejde, der skal til for at skabe en flot have. Vi kombinerer vores mange kompetencer for at løse netop din opgave professionelt.",
    features: [
      "Totalentreprise på haveanlæg",
      "Rydning af buske og træer",
      "Jordarbejde og planering",
      "Etablering af bede",
      "Professionel rådgivning"
    ],
    icon: "TreePine",
    image: "/kundebilleder/imageye___-_imgi_67_666971542_122134739847028357_2233004686136187369_n.jpeg",
    gallery: [
      "/kundebilleder/imageye___-_imgi_67_666971542_122134739847028357_2233004686136187369_n.jpeg",
      "/kundebilleder/imageye___-_imgi_67_555672424_122103982365028357_244424941638314993_n.jpeg"
    ]
  }
];

export const beforeAfterProjects = [
  {
    before: '/kundebilleder/imageye___-_imgi_67_580513836_122112883665028357_4357458551880717089_n.jpeg',
    after: '/kundebilleder/imageye___-_imgi_67_581806620_122112883713028357_8265413216333731729_n.jpeg',
    title: 'Fliserens & Vedligeholdelse',
    category: 'Belægning',
    description: 'Se hvordan en grundig fliserens og ukrudtsbekæmpelse kan transformere en hel indkørsel. Fra gråt og trist til som nyt.'
  },
  {
    before: '/kundebilleder/imageye___-_imgi_67_667405123_122135105097028357_7106171026018513753_n.jpeg',
    after: '/kundebilleder/imageye___-_imgi_67_668583084_122135105049028357_2729473811509692273_n.jpeg',
    title: 'Haveforvandling & Ny Plæne',
    category: 'Nyanlæg',
    description: 'Fra råt anlægsarbejde til en færdig, grøn oase. Vi håndterer hele processen fra flisearbejde til udlægning af græs.'
  }
];

export const galleryImages = [
  "/kundebilleder/imageye___-_imgi_67_666971542_122134739847028357_2233004686136187369_n.jpeg",
  "/kundebilleder/imageye___-_imgi_67_672023651_122135999259028357_6691622361253398711_n.jpeg",
  "/kundebilleder/imageye___-_imgi_2_548209826_122096182263028357_4279363447877866911_n.jpeg",
  "/kundebilleder/imageye___-_imgi_67_672196004_122135999001028357_8116323758983306129_n.jpeg",
  "/kundebilleder/imageye___-_imgi_67_673808045_122135999193028357_9162352892792381928_n.jpeg",
  "/kundebilleder/imageye___-_imgi_67_667405123_122135105097028357_7106171026018513753_n.jpeg",
  "/kundebilleder/imageye___-_imgi_67_668896790_122135104761028357_6348603269610059595_n.jpeg",
  "/kundebilleder/imageye___-_imgi_67_667357066_122134739817028357_4663739399389733083_n.jpeg",
  "/kundebilleder/imageye___-_imgi_67_670004997_122135104821028357_5714803067483684178_n.jpeg",
  "/kundebilleder/imageye___-_imgi_67_668583084_122135105049028357_2729473811509692273_n.jpeg",
  "/kundebilleder/imageye___-_imgi_67_555672424_122103982365028357_244424941638314993_n.jpeg",
  "/kundebilleder/imageye___-_imgi_67_668492806_122134739943028357_6697783164957947626_n.jpeg"
];
